// extracted by mini-css-extract-plugin
export default {"btnStyle":"Counter_btnStyle__zdylC","bgColorLight":"Counter_bgColorLight__Y7wtY"};